import React from "react";
import { Edit3, Trash2, Star } from "lucide-react";

const TestimonialList = ({ testimonials = [], onEdit, onDelete }) => {
  const renderStars = (count = 0) => (
    <div className="flex justify-center">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          size={16}
          className={`${
            i < count ? "text-yellow-400 fill-yellow-400" : "text-gray-300"
          }`}
        />
      ))}
    </div>
  );

  return (
    <div>
      <h2 className="text-2xl font-semibold text-blue-600 mb-6">
        Client Testimonials
      </h2>
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 bg-white rounded-xl shadow-sm">
          <thead>
            <tr className="bg-green-600 text-white">
              <th className="px-6 py-3 text-left font-semibold">Client</th>
              <th className="px-6 py-3 text-left font-semibold">Message</th>
              <th className="px-6 py-3 text-center font-semibold">Rating</th>
              <th className="px-6 py-3 text-center font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {testimonials.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  className="px-6 py-6 text-center text-gray-400 text-sm"
                >
                  No testimonials added yet.
                </td>
              </tr>
            ) : (
              testimonials.map((t) => (
                <tr
                  key={t.testimonial_id || t.id}
                  className="border-t hover:bg-gray-50 transition text-sm"
                >
                  <td className="px-6 py-3 font-medium text-gray-800">
                    {t.name}
                  </td>
                  <td className="px-6 py-3 text-gray-600 max-w-md truncate">
                    {t.text}
                  </td>
                  <td className="px-6 py-3 text-center">
                    {renderStars(t.rating)}
                  </td>
                  <td className="px-6 py-3 text-center">
                    <button
                      onClick={() => onEdit && onEdit(t)}
                      className="text-blue-600 hover:text-blue-800"
                    >
                      <Edit3 size={18} />
                    </button>
                    <button
                      onClick={() =>
                        onDelete &&
                        onDelete(t.testimonial_id ? t.testimonial_id : t.id)
                      }
                      className="ml-3 text-red-600 hover:text-red-800"
                    >
                      <Trash2 size={18} />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TestimonialList;
